export const OwnershipUtmSource = {
  Qr: 'qr'
};

export const OwnershipUtmCampaign = {
  BrillaChangeOfOwnership: 'brilla_cambio_de_titular'
};
